import {bp} from './namespace.js';
import './bootstrap.js';

$.extend(true, bp, {
  validate: (function () {
    var constraints;
    var show_required_field_error;
    var number_of_required_fields;
    var show_min_value_error;
    var number_of_min_value_fields;
    var email_field_has_error;
    var email_field_name;
    var unitsHaveErrors;
    var pictureHasErrors;
    var lastErrors = {};

    return {
      init: function (rules, message) {
        constraints = rules;
        $.extend(true, constraints, message);
      },
      handleFormSubmit: function (form, isListingForm = false, hasUnits = false) {
        show_required_field_error = false;
        show_min_value_error = false;
        pictureHasErrors = false;
        unitsHaveErrors = false;

        number_of_required_fields = 0;
        var errors = validate(form, constraints, {format: 'grouped'});
        lastErrors = errors || {};
        var required_field_error = document.querySelector('#required-error');
        var email_field_error = document.querySelector('#invalid-email-error');
        var min_value_error = document.querySelector('#min-value-error');
        var server_errors = document.querySelectorAll('.server-errors');

        var inputs = document.querySelectorAll('input, textarea, select');
        Array.prototype.forEach.call(inputs, function (input) {
          input.addEventListener('change', function () {
            var inputErrors = validate(form, constraints) || {};
            lastErrors = inputErrors;
            bp.validate.showErrorsForInput(this, inputErrors[this.name]);
          });
        });

        if (isListingForm) {
          var estatePics = document.querySelectorAll('#estate_pics .filepond--file-wrapper > input');
          if (estatePics && estatePics.length === 0) {
            pictureHasErrors = true;
          } else {
            pictureHasErrors = false;
          }

          if (hasUnits) {
            var num_of_units = parseInt($('#id_estate_offer_units-TOTAL_FORMS').val(), 10);
            for (var i = 0; i < num_of_units; i++) {
              var validates = this.validateUnitForm(i);
              if (!validates) {
                $('#unit_panel_heading_' + i + ' .show-detail-link').click();
                unitsHaveErrors = true;
              } else {
                unitsHaveErrors = false;
              }
            }
          }
        }

        if (!errors && !unitsHaveErrors && !pictureHasErrors) {
          if (required_field_error !== null) {
            this.destroyMessage('required-error');
          }
          if (email_field_error !== null) {
            this.destroyMessage('invalid-email-error');
          }
          if (min_value_error !== null) {
            this.destroyMessage('min-value-error');
          }
          // Validation passed — submit the form. (Restored: the bp.js bundle
          // refactor dropped this call, which silently broke login/register/
          // contact and listing-form submission.)
          form.submit();
        } else {
          Array.prototype.forEach.call(server_errors, function (item) {
            if (item.hasChildNodes()) {
              while (item.firstChild) {
                item.removeChild(item.firstChild);
              }
            }
          });

          this.destroyMessage('required-error');
          this.destroyMessage('min-value-error');
          this.showErrors(form, errors);

          if (isListingForm) {
            if (unitsHaveErrors) {
              for (var x = 0; x < num_of_units; x++) {
                this.addUnitErrors(x);
              }
            }

            if (pictureHasErrors) {
              $('#estate_pics .filepond--panel-root').addClass('error');
            }
          }

          this.showRequiredErrorMessage(errors, required_field_error, isListingForm, unitsHaveErrors, pictureHasErrors);
          this.showMinValueErrorMessage(errors, min_value_error, isListingForm);
          this.showEmailErrorMessage(email_field_error);
        }
        return false;
      },
      showEmailErrorMessage: function (email_field_error) {
        email_field_has_error = $("input[type='email']").parent().hasClass('has-error');
        if (email_field_has_error) {
          email_field_name = $("input[type='email']").attr('name');
          if (bp.validate.isInvalidEmail((lastErrors || {})[email_field_name]) && email_field_error === null) {
            this.createMessage('Invalid email', 'invalid-email-error');
          } else if (!bp.validate.isInvalidEmail((lastErrors || {})[email_field_name]) && email_field_error !== null) {
            this.destroyMessage('invalid-email-error');
          }
        } else if (!email_field_has_error && email_field_error !== null) {
          this.destroyMessage('invalid-email-error');
        }
      },
      showMinValueErrorMessage: function (errors, min_value_error, isListingForm = false) {
        number_of_min_value_fields = 0;
        _.each(errors, function (e) {
          bp.validate.fieldhasMinValue(e) ? (
            show_min_value_error = true,
            ++number_of_min_value_fields
          ) : (
            show_min_value_error
          );
        });
        if (show_min_value_error) {
          this.createMessage('De minimale waarde moet groter zijn dan 0', 'min-value-error');
        } else if (!show_min_value_error && min_value_error !== null) {
          if (isListingForm) {
            $('#id_min_value_error').remove();
          }
          this.destroyMessage('min-value-error');
        }
      },
      showRequiredErrorMessage: function (errors, required_field_error, isListingForm = false, unitsHaveErrors = false, pictureHasErrors = false) {
        number_of_required_fields = 0;

        _.each(errors, function (e) {
          bp.validate.fieldIsRequiredError(e) ? (
            show_required_field_error = true,
            ++number_of_required_fields
          ) : (
            show_required_field_error
          );
        });

        if (show_required_field_error || unitsHaveErrors || pictureHasErrors) {
          this.createMessage('Deze velden zijn verplicht', 'required-error');
        } else if (!show_required_field_error && !unitsHaveErrors && !pictureHasErrors && required_field_error !== null) {
          if (isListingForm) {
            $('#id_required_error').remove();
          }
          this.destroyMessage('required-error');
        }
      },
      showErrors: function (form, errors) {
        _.each(form.querySelectorAll('input[name], select[name]'), function (input) {
          bp.validate.showErrorsForInput(input, errors && errors[input.name]);
        });
      },
      showErrorsForInput: function (input, errors) {
        var formGroup = this.closestParent(input.parentNode, 'form-group');
        if (formGroup) {
          this.resetFormGroup(formGroup);
        }
        if (errors) {
          formGroup.classList.add('has-error');
        }
      },
      validateLength: function (arr) {
        if (Array.isArray(arr) && arr.length > 0) {
          return undefined;
        }
        return {'unit_useplans': ['Select at least one useplan']};
      },
      validateUnitForm: function (ndx) {
        var errors = this.getUnitErrors(ndx);
        return Object.values(errors).filter((v) => v !== undefined).length === 0;
      },
      getUnitErrors: function (ndx) {
        var select = $('#id_estate_offer_units-' + ndx + '-unit_floor');
        var unit_floor_area = $('#id_estate_offer_units-' + ndx + '-unit_floor_area');
        var unit_type = $(`#id_estate_offer_units-${ndx}-unit_useplans`);
        var unit_rent_price = $('#id_estate_offer_units-' + ndx + '-unit_rent_price');

        var errors = {};
        errors[select.attr('id')] = validate.single(select.val(), present);
        errors[unit_floor_area.attr('id')] = validate.single(unit_floor_area.val(), numeric);
        errors[unit_type.attr('id')] = validateLength(unit_type.select2('data'));
        // Restored: validate the unit rent price when filled (dropped in the refactor).
        if (unit_rent_price.val() !== '') {
          errors[unit_rent_price.attr('id')] = validate.single(unit_rent_price.val(), numeric);
        }
        return errors;
      },
      addUnitErrors: function (ndx) {
        var errors = this.getUnitErrors(ndx);
        for (let [key, value] of Object.entries(errors)) {
          this.showUnitErrorsForInput(key, value);
          // Restored: explicit rent-price error message (dropped in the refactor).
          if (key.includes('unit_rent_price') && value !== undefined && $('#unit_error_messages_custom').length === 0) {
            $('#error-message').append('<div style="font-size: 16px" id="unit_error_messages_custom">Foutieve invoer in veld</div>');
          }
        }
      },
      showUnitErrorsForInput: function (id, errors) {
        var formGroup = this.closestParent(document.getElementById(id).parentNode, 'form-group');
        if (formGroup) {
          // keep legacy behaviour
        }
        if (errors) {
          $('#' + id).closest('.form-group').addClass('has-error');
        }
      },
      createMessage: function (message, id) {
        var section = document.createElement('p');
        var error_message_block = document.querySelector('div#error-message');

        section.classList.add('error-text');
        section.id = id;
        section.innerText = message;
        error_message_block.appendChild(section);

        if (bp.bootstrap.get_bootstrap_environment() === 'xs') {
          var error_message_block_mobile = document.querySelector('div#error-message-mobile');
          if (error_message_block_mobile) {
            error_message_block_mobile.appendChild(section);
            $('.bp-mobile-sticky-button').addClass('error-state');
          }
        }
      },
      destroyMessage: function (id) {
        $('#' + id).remove();

        if (bp.bootstrap.get_bootstrap_environment() === 'xs' && $('.bp-mobile-sticky-button').length > 0) {
          $('.bp-mobile-sticky-button').removeClass('error-state');
        }
      },
      resetFormGroup: function (formGroup) {
        formGroup.classList.remove('has-error');
        $('#unit_error_messages').remove();
      },
      fieldIsRequiredError: function (element) {
        return element.toString().includes('required');
      },
      fieldhasMinValue: function (element) {
        return element.toString().includes('must be greater than');
      },
      isInvalidEmail: function (element) {
        return String(element).includes('is not a valid email');
      },
      closestParent: function (child, className) {
        if (!child || child === document) {
          return null;
        }
        if (child.classList.contains(className)) {
          return child;
        }
        return this.closestParent(child.parentNode, className);
      },
    };
  })(),
});

export {bp};
